import { config } from '../config/config';
import { HttpServices } from '../Helper';

export const CreateUnitDocument = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/UnitDocument/CreateUnitDocument`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const UpdateUnitDocument = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/UnitDocument/UpdateUnitDocument`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const CreateScopeDocument = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/ScopeDocument/CreateScopeDocument`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const UpdateScopeDocument = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/ScopeDocument/UpdateScopeDocument`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllScopeDocuments = async ({ scopeId, pageSize, pageIndex ,scopeTypeId}) => {
  const queryList = [];
  if (scopeId) queryList.push(`scopeId=${scopeId}`);
  if (scopeTypeId) queryList.push(`scopeTypeId=${scopeTypeId}`);
  if (pageSize || pageSize === 0) queryList.push(`pageSize=${pageSize}`);
  if (pageIndex || pageIndex === 0) queryList.push(`pageIndex=${pageIndex + 1}`);
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/ScopeDocument/GetAllScopeDocuments?${queryList.join('&')}`

  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllDocumentsForTransactionById = async ({ unitTransactionId , pageSize, pageIndex }) => {
  const queryList = [];
  if (pageSize || pageSize === 0) queryList.push(`pageSize=${pageSize}`);
  if (pageIndex || pageIndex === 0) queryList.push(`pageIndex=${pageIndex + 1}`);
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/Unit/GetAllDocumentsForTransactionById/${unitTransactionId}?${queryList.join('&')}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const DeleteScopeDocument = async (scopeDocumentId) => {
  const result = await HttpServices.delete(
    `${config.server_address}/CrmDfm/ScopeDocument/DeleteScopeDocument?scopeDocumentId=${scopeDocumentId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetScopeCategoryDocuments = async (body) => {

  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/ScopeDocument/GetScopeCategoryDocuments`,body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};


export const ShareScopeDocuments = async (body ,  {isFromDeveloper}) => {

  const queryList = [];
  if (isFromDeveloper) queryList.push(`isFromDeveloper=${true}`);
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/ScopeDocument/ShareScopeDocuments?${queryList.join('&')}`, body)
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetAllShareDocumentLog = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/ScopeDocument/GetAllShareDocumentLog`,body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};